module.exports = __webpack_public_path__ + "media/video_bg.d6aa0a05.mp4";